import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/shared/services/users.service';

@Component({
  selector: 'app-scs',
  templateUrl: './scs.component.html',
  styleUrls: ['./scs.component.css']
})
export class ScsComponent implements OnInit {
  data = {
    module : "Speed Control System"
  }

  constructor(
    private usersService : UsersService,
    private router: Router
  ) { 
    
  }

  ngOnInit(): void {
  }

  async completed() {
    
    let courseCompleted = {
      module4: this.data.module
    }
    await this.usersService.userProgress(courseCompleted);
   
    this.router.navigate(['/assessment-2']);
  }


}
